// apps/web/src/components/shell/AppFooter.jsx
// Minimal footer for AppShell. Reuses .app-footer styles from layout.css (tokenized).

import React, { useMemo } from "react";
import { APP_VERSION, APP_VERSION_DATE } from "@tennis-matches/core/version";

function read(t, key, fallback = "") {
  const v = typeof t === "function" ? t(key) : key;
  return (v && v !== key ? v : fallback || key || "").toString();
}

export function AppFooter({ t, authenticated = false }) {
  const versionLabel = useMemo(() => {
    const v = String(APP_VERSION || "").trim();
    const d = String(APP_VERSION_DATE || "").trim();
    const label = v ? `v${v}` : "";
    const dateLabel = d ? ` (${d})` : "";
    return (label + dateLabel).trim();
  }, []);

  return (
    <footer
      className={`app-footer${authenticated ? " app-footer--authenticated" : ""}`}
      data-footer
      role="contentinfo"
    >
      <div className="app-footer__inner">
        <a className="app-footer__link" href="/impressum">
          {read(t, "footer.impressum", "Impressum")}
        </a>
        <a className="app-footer__link" href="/datenschutz">
          {read(t, "footer.privacy", "Datenschutz")}
        </a>
        <span
          className="app-footer__version"
          aria-label={read(t, "common.version")}
        >
          {versionLabel}
        </span>
      </div>
    </footer>
  );
}
